import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@pearsontechnology/aero-components';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

import {
  ThumbnailBoxOverlay,
  ThumbnailBoxButtonText,
} from './styles';

const ThumbnailOverlay = ({ onSelect, hovered }) => (
  <ThumbnailBoxOverlay
    hovered={hovered}
  >
    <Button
      onClick={onSelect}
      width={146}
      primary
    >
      <ThumbnailBoxButtonText>
        <FormattedMessage {...messages.thumbnailChoose} />
      </ThumbnailBoxButtonText>
    </Button>
  </ThumbnailBoxOverlay>
);

ThumbnailOverlay.propTypes = {
  templateId: PropTypes.string,
  templateType: PropTypes.string,
  onSelect: PropTypes.func,
  hovered: PropTypes.bool,
  disablePreview: PropTypes.bool,
};

export default ThumbnailOverlay;
